// Supported Admin overviews and presentation only; counting rules live in the API.
export const overviewNames = [
  'customers',
  'contracts',
  'products',
  'product-groups',
  'subscriptions',
  'users',
  'customer-users',
  'customer-api-accounts',
  'admin-api-accounts',
  'customer-contacts',
  'contacts',
  'invoices',
  'sepa',
  'domains',
  'dmarc',
  'ssl-certificates',
  'projects',
  'project-tasks',
  'project-task-types',
  'project-task-time-tracking',
  'email-logs',
  'sms-logs',
  'email-queue',
  'email-triggers',
  'vpn-certificates',
  'vpn-firewalls',
  'vpn-mac-address-groups',
  'licenses',
  'license-slas',
  'license-partner-programs',
  'customer-offers',
  'sales-orders',
  'purchase-orders',
  'stock',
  'assets',
  'webhosting',
  'webhosting-packages',
  'domain-ns-groups',
  'sharingcenter-calendars',
  'sharingcenter-contacts',
  'sharingcenter-groups',
  'sharingcenter-profiles',
  'customer-phone-numbers',
  'customer-sip-accounts',
  'authmanagement-roles',
  'feedback-questions',
  'whitelabels',
  'vat',
  'audit-logs',
  'account-invitations',
  'settings',
]

export const overviewMetricPresentation = {
  openPurchaseOrders: { icon: 'sym_o_shopping_cart', color: 'primary' },
  awaitingPurchaseOrders: { icon: 'sym_o_local_shipping', color: 'warning' },
  overduePurchaseOrders: { icon: 'sym_o_event_busy', color: 'negative' },
  reservedStock: { icon: 'sym_o_bookmark', color: 'warning' },
  availableStock: { icon: 'sym_o_inventory_2', color: 'positive' },
  reservedAssets: { icon: 'sym_o_bookmark', color: 'warning' },
  supplierWarrantiesExpiring: { icon: 'sym_o_event_upcoming', color: 'warning' },
  customerWarrantiesExpiring: { icon: 'sym_o_event_upcoming', color: 'warning' },
  withoutRoles: { icon: 'sym_o_person_off', color: 'warning' },
  recentAuditEvents: { icon: 'sym_o_schedule', color: 'primary' },
  failedAuditEvents: { icon: 'sym_o_error', color: 'negative' },
  impersonatedAuditEvents: { icon: 'sym_o_supervised_user_circle', color: 'primary' },
  initializedBatches: { icon: 'sym_o_playlist_add_check', color: 'primary' },
  generatedBatches: { icon: 'sym_o_description', color: 'positive' },
  runningContracts: {
    icon: 'sym_o_verified',
    color: 'positive',
  },
  endingContracts: {
    icon: 'sym_o_event_upcoming',
    color: 'warning',
  },
  licenseProducts: {
    icon: 'sym_o_workspace_premium',
  },
  hostingProducts: {
    icon: 'sym_o_dns',
  },
  bundles: {
    icon: 'sym_o_inventory_2',
  },
  monthly: {
    icon: 'sym_o_calendar_month',
  },
  yearly: {
    icon: 'sym_o_event_repeat',
  },
  cancelled: {
    icon: 'sym_o_event_busy',
    color: 'warning',
  },
  sso: {
    icon: 'sym_o_verified_user',
    color: 'positive',
  },
  verified: {
    icon: 'sym_o_how_to_reg',
    color: 'positive',
  },
  unverified: {
    icon: 'sym_o_person_alert',
    color: 'warning',
  },
  regularUsers: {
    icon: 'sym_o_person',
  },
  virtualUsers: {
    icon: 'sym_o_support_agent',
  },
  apiAccounts: {
    icon: 'sym_o_api',
  },
  receivesMail: {
    icon: 'sym_o_mark_email_read',
    color: 'positive',
  },
  noMail: {
    icon: 'sym_o_unsubscribe',
  },
  customAddress: {
    icon: 'sym_o_location_on',
  },
  draftInvoices: {
    icon: 'sym_o_edit_document',
  },
  openInvoices: {
    icon: 'sym_o_payments',
    color: 'warning',
  },
  autoRenew: {
    icon: 'sym_o_autorenew',
    color: 'positive',
  },
  noAutoRenew: {
    icon: 'sym_o_event_busy',
    color: 'warning',
  },
  quarantine: {
    icon: 'sym_o_shield',
    color: 'negative',
  },
  wildcard: {
    icon: 'sym_o_asterisk',
  },
  domainValidated: {
    icon: 'sym_o_verified',
  },
  renewSoon: {
    icon: 'sym_o_event_upcoming',
    color: 'warning',
  },
  openTasks: {
    icon: 'sym_o_playlist_add',
  },
  startedTasks: {
    icon: 'sym_o_play_circle',
    color: 'warning',
  },
  doneTasks: {
    icon: 'sym_o_task_alt',
    color: 'positive',
  },
  sent: {
    icon: 'sym_o_send',
    color: 'positive',
  },
  notSent: {
    icon: 'sym_o_sms_failed',
    color: 'warning',
  },
  lastDay: {
    icon: 'sym_o_today',
  },
  delivered: {
    icon: 'sym_o_done_all',
    color: 'positive',
  },
  online: {
    icon: 'sym_o_wifi',
    color: 'positive',
  },
  offline: {
    icon: 'sym_o_wifi_off',
    color: 'warning',
  },
  defaultGateway: {
    icon: 'sym_o_route',
  },
  active: {
    icon: 'sym_o_check_circle',
    color: 'positive',
  },
  withDefaultContract: {
    icon: 'sym_o_description',
  },
  recentlyCreated: {
    icon: 'sym_o_add_circle',
  },
  recentlyUpdated: {
    icon: 'sym_o_update',
  },
  withRoles: {
    icon: 'sym_o_admin_panel_settings',
  },
  withContract: {
    icon: 'sym_o_description',
  },
  invoicedEntries: {
    icon: 'sym_o_receipt_long',
    color: 'positive',
  },
  uninvoicedEntries: {
    icon: 'sym_o_pending_actions',
    color: 'warning',
  },
  queued: {
    icon: 'sym_o_outbox',
  },
  awaitingApproval: {
    icon: 'sym_o_pending',
    color: 'warning',
  },
  failed: {
    icon: 'sym_o_error',
    color: 'negative',
  },
  enabled: {
    icon: 'sym_o_check_circle',
    color: 'positive',
  },
  disabled: {
    icon: 'sym_o_pause_circle',
    color: 'blue-grey',
  },
  draftOffers: {
    icon: 'sym_o_edit_document',
  },
  sentOffers: {
    icon: 'sym_o_send',
  },
  acceptedOffers: {
    icon: 'sym_o_task_alt',
    color: 'positive',
  },
  activeHosting: {
    icon: 'sym_o_cloud_done',
    color: 'positive',
  },
  pendingHosting: {
    icon: 'sym_o_pending',
    color: 'warning',
  },
  suspendedHosting: {
    icon: 'sym_o_cloud_off',
    color: 'negative',
  },
  publicProfiles: {
    icon: 'sym_o_public',
  },
  meetingProfiles: {
    icon: 'sym_o_videocam',
  },
  chatProfiles: {
    icon: 'sym_o_chat',
  },
  inbound: {
    icon: 'sym_o_call_received',
  },
  outbound: {
    icon: 'sym_o_call_made',
  },
  encryptedTransport: {
    icon: 'sym_o_lock',
    color: 'positive',
  },
  internalRoles: {
    icon: 'sym_o_badge',
  },
  customerRoles: {
    icon: 'sym_o_apartment',
  },
  pendingInvitations: {
    icon: 'sym_o_hourglass_top',
  },
  acceptedInvitations: {
    icon: 'sym_o_how_to_reg',
    color: 'positive',
  },
  archived: {
    icon: 'sym_o_archive',
    color: 'blue-grey',
  },
  overdueInvoices: {
    icon: 'sym_o_notification_important',
    color: 'negative',
  },
}
